/* Home intro slides: cross-fade on a timer, dots, swipe. The timer stops on hover/focus,
   while off-screen or the tab is hidden, and never runs for reduced motion. */
(() => {
  document.querySelectorAll('[data-menam-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('.menam-hero__slide')];
    const dots = [...hero.querySelectorAll('.menam-hero__dot')];
    if (slides.length < 2) return;

    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const auto = hero.hasAttribute('data-autoplay') && !still;
    const wait = (parseInt(hero.dataset.interval, 10) || 6) * 1000;
    let index = 0;
    let timer = 0;
    let held = false;
    let seen = true;

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((slide, n) => {
        const on = n === index;
        slide.classList.toggle('is-active', on);
        slide.toggleAttribute('inert', !on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach((dot, n) => dot.setAttribute('aria-current', String(n === index)));
    };

    const stop = () => {
      window.clearTimeout(timer);
      timer = 0;
    };

    const start = () => {
      stop();
      if (!auto || held || !seen || document.hidden) return;
      timer = window.setTimeout(() => {
        show(index + 1);
        start();
      }, wait);
    };

    dots.forEach((dot) =>
      dot.addEventListener('click', () => {
        show(parseInt(dot.dataset.index, 10));
        start();
      })
    );

    hero.addEventListener('mouseenter', () => ((held = true), stop()));
    hero.addEventListener('mouseleave', () => ((held = false), start()));
    hero.addEventListener('focusin', () => ((held = true), stop()));
    hero.addEventListener('focusout', (e) => {
      if (!hero.contains(e.relatedTarget)) (held = false), start();
    });
    document.addEventListener('visibilitychange', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        seen = e.isIntersecting;
        start();
      }).observe(hero);
    }

    let x0 = null;
    hero.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    hero.addEventListener(
      'touchend',
      (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40) return;
        show(index + (dx < 0 ? 1 : -1));
        start();
      },
      { passive: true }
    );

    start();
  });
})();
